module.exports = __webpack_public_path__ + "static/media/image022.54d3eade.jpg";